import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';

import { CustomOperationsHeader } from './components/CustomOperationsHeader';
import { CustomOperationsTable } from './components/CustomOperationsTable';
import { HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { Pagination } from '@/modules/common/components/Pagination';

import { isRequestError } from '@warrenbrasil/web-http';
import {
  getCustomOperationsList,
  CustomOperationPosition,
  GetCustomOperationsListResponse
} from '@/modules/trade/services/instruments';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomOperations',
  setup(__props) {

const items = ref<CustomOperationPosition[]>([]);
const isLoading = ref<boolean>(false);
const hasError = ref<boolean>(false);
const updatedAtMessage = ref<string>('');
const abortSignal = ref<AbortController | null>(null);
const pagination = ref({
  currentPage: 1,
  totalPages: 1,
  itemsPerPage: 10
});

const mountView = (data: GetCustomOperationsListResponse) => {
  const {
    updatedAt,
    items: derivativesItems,
    pagination: { itemsPerPage, totalPages, page }
  } = data;
  updatedAtMessage.value = updatedAt.formatted;
  items.value = derivativesItems;
  pagination.value = {
    totalPages,
    itemsPerPage,
    currentPage: page
  };
};

const getCustomOperationsData = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;
    if (abortSignal.value) abortSignal.value.abort();
    abortSignal.value = new AbortController();

    const data = await getCustomOperationsList(
      {
        itemsPerPage: pagination.value.itemsPerPage,
        page: pagination.value.currentPage
      },
      abortSignal.value.signal
    );

    mountView(data);
  } catch (e) {
    if (isRequestError(e) && e.type === 'canceled') return;
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const handleOnPageChange = (page: number) => {
  pagination.value.currentPage = page;
  getCustomOperationsData();
};

onMounted(() => getCustomOperationsData());

return { __sfc: true,items, isLoading, hasError, updatedAtMessage, abortSignal, pagination, mountView, getCustomOperationsData, handleOnPageChange, CustomOperationsHeader, CustomOperationsTable, HelperViewStatus, Pagination }
}

})